import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.47 8.34705C15.6009 8.34705 15.7265 8.39836 15.82 8.48997L16.32 9.01997C16.3668 9.06646 16.404 9.12176 16.4294 9.18269C16.4548 9.24362 16.4679 9.30897 16.4679 9.37497C16.4679 9.44098 16.4548 9.50633 16.4294 9.56726C16.404 9.62819 16.3668 9.68349 16.32 9.72997L10.7 15.35C10.6551 15.3978 10.6009 15.4359 10.5407 15.462C10.4805 15.488 10.4156 15.5015 10.35 15.5015C10.2844 15.5015 10.2195 15.488 10.1593 15.462C10.0991 15.4359 10.0449 15.3978 9.99997 15.35L7.64997 12.98C7.60311 12.9335 7.56591 12.8782 7.54053 12.8173C7.51514 12.7563 7.50208 12.691 7.50208 12.625C7.50208 12.559 7.51514 12.4936 7.54053 12.4327C7.56591 12.3718 7.60311 12.3165 7.64997 12.27L8.17997 11.74C8.22486 11.6921 8.27908 11.654 8.33928 11.628C8.39948 11.6019 8.46438 11.5885 8.52997 11.5885C8.59557 11.5885 8.66047 11.6019 8.72067 11.628C8.78087 11.654 8.83508 11.6921 8.87997 11.74L10.38 13.23L15.12 8.48997C15.2134 8.39836 15.3391 8.34705 15.47 8.34705Z"
      fill="#1C9A7F"
    />
  </svg>
);
const SvgVwithcircleColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgVwithcircleColored;
